<template>
  <div>
    <div class="text-big">
      <b-badge variant="dark" :title="this.$gettext('Scheduled')" v-b-tooltip class="mr-1">{{order.shippings_amount}}</b-badge>
      <b-badge :variant="releasedBg" :title="this.$gettext('Released')" v-b-tooltip class="mr-1">{{order.shippings.filter(x => x.status !== 'CANCELED').length}}</b-badge>
      <b-badge :variant="deliveredBg" :title="this.$gettext('Delivered')" v-b-tooltip >{{order.shippings.filter(x => x.status === 'DELIVERED').length}}</b-badge>
    </div>
    <div class="text-center">
      <b-badge v-if="order.shippings.length > 0" role="link" v-b-modal="'modalOrderShippingsX' + order.id">View Shipments</b-badge>
    </div>
    <b-modal v-if="order.shippings.length > 0" size="xl" :id="'modalOrderShippingsX' + order.id" :ref="'modalOrderShippingsX' + order.id" hide-footer>
      <template #modal-title>
        <span class="mr-3"><translate>Order Shipments</translate></span>
        <b-button
          size="sm"
          variant="primary"
          :disabled="['draft', 'pending', 'canceled', 'done'].includes(order.status)"
          @click="openAddShipments"
        >
          <translate>Add Shipments</translate>
        </b-button>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <api-list type="shippingsInOrder" :model="models.shippingsInOrder" :title="''" :prePerPage="10" :preFilters="[['shipping_order_id', 'eq', order.id]]" inModal filterOnMount hideFilters />
    </b-modal>
    <b-modal
      size="sm"
      :id="'modalAddShipmentsX' + order.id"
      :ref="'modalAddShipmentsX' + order.id"
      :title="this.$gettext('Add Shipments')"
      hide-footer
    >
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <b-form-group :label="this.$gettext('Shipments amount')" class="mb-3">
        <b-form-input
          v-model.number="shipmentsAmount"
          type="number"
          min="1"
          autofocus
        />
      </b-form-group>
      <b-form-group>
        <b-button size="sm" variant="secondary" :disabled="addingShipments" @click="$bvModal.hide('modalAddShipmentsX' + order.id)">
          <translate>Cancel</translate>
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          :disabled="!shipmentsAmount || shipmentsAmount < 1 || addingShipments"
          @click="addShipments"
        >
          <b-spinner small v-if="addingShipments" />
          <translate>Accept</translate>
        </b-button>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import ApiList from '@/components/ApiLists/ApiList'
import { ShippingOrderService } from '@/services/api'

export default {
  name: 'ShippingOrdersListItemShippingsAmount',
  components: {
    ApiList
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      shipmentsAmount: null,
      addingShipments: false
    }
  },
  methods: {
    openAddShipments() {
      this.shipmentsAmount = null
      this.$bvModal.show('modalAddShipmentsX' + this.order.id)
    },
    async addShipments() {
      if (!this.shipmentsAmount || this.shipmentsAmount < 1) {
        return
      }
      this.addingShipments = true
      try {
        await ShippingOrderService.addG3Shippings(this.order.id, {
          shipments_amount: this.shipmentsAmount
        })
        setTimeout(() => {
          this.$bvModal.hide('modalAddShipmentsX' + this.order.id)
          this.$root.$emit('bv::refresh::table', 'shippingsInOrder')
          this.addingShipments = false
        }, 2000)
      } finally {
        // no cleanup needed
      }
    }
  },
  computed: {
    releasedBg() {
      return this.order.shippings_amount && this.order.shippings.length === 0 ? 'warning' : 'success'
    },
    deliveredBg() {
      if (this.releasedBg === 'warning' && this.order.shippings.filter(x => x.status === 'DELIVERED').length === 0) {
        return 'warning'
      }
      return this.releasedBg === 'success' && this.order.shippings.filter(x => x.status === 'DELIVERED').length < this.order.shippings.filter(x => x.status !== 'CANCELED').length ? 'danger' : 'success'
    }
  }
}
</script>